{
	"__header__": {
		"fileType": "LDtk Project JSON",
		"app": "LDtk",
		"doc": "https://ldtk.io/json",
		"schema": "https://ldtk.io/files/JSON_SCHEMA.json",
		"appAuthor": "Sebastien 'deepnight' Benard",
		"appVersion": "1.4.1",
		"url": "https://ldtk.io"
	},
	"iid": "3e1d5820-6280-11ee-862e-a1d25684a23a",
	"jsonVersion": "1.4.1",
	"appBuildId": 471015,
	"nextUid": 113,
	"identifierStyle": "Capitalize",
	"toc": [],
	"worldLayout": "Free",
	"worldGridWidth": 256,
	"worldGridHeight": 256,
	"defaultLevelWidth": 256,
	"defaultLevelHeight": 256,
	"defaultPivotX": 0,
	"defaultPivotY": 0,
	"defaultGridSize": 32,
	"defaultEntityWidth": 16,
	"defaultEntityHeight": 16,
	"bgColor": "#40465B",
	"defaultLevelBgColor": "#696A79",
	"minifyJson": false,
	"externalLevels": false,
	"exportTiled": false,
	"simplifiedExport": true,
	"imageExportMode": "None",
	"exportLevelBg": true,
	"pngFilePattern": null,
	"backupOnSave": false,
	"backupLimit": 10,
	"backupRelPath": null,
	"levelNamePattern": "Level_%idx",
	"tutorialDesc": null,
	"customCommands": [],
	"flags": [],
	"defs": { "layers": [
		{
			"__type": "Entities",
			"identifier": "Entities",
			"type": "Entities",
			"uid": 105,
			"doc": null,
			"uiColor": null,
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 0.6,
			"hideInList": false,
			"hideFieldsWhenInactive": true,
			"canSelectWhenInactive": true,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": [],
			"excludedTags": [],
			"intGridValues": [],
			"intGridValuesGroups": [],
			"autoRuleGroups": [],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": null,
			"tilePivotX": 0,
			"tilePivotY": 0
		},
		{
			"__type": "IntGrid",
			"identifier": "Terrain",
			"type": "IntGrid",
			"uid": 7,
			"doc": null,
			"uiColor": "#FF0000",
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 1,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": true,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": [],
			"excludedTags": [],
			"intGridValues": [{ "value": 1, "identifier": null, "color": "#000000", "tile": null, "groupUid": 0 }],
			"intGridValuesGroups": [],
			"autoRuleGroups": [{ "uid": 8, "name": "Rules for #1", "color": null, "icon": null, "active": true, "isOptional": false, "rules": [
				{
					"uid": 9,
					"active": true,
					"size": 3,
					"tileIds": [100],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 671464,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 10,
					"active": true,
					"size": 3,
					"tileIds": [35],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3331425,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 11,
					"active": true,
					"size": 3,
					"tileIds": [92],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1119605,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 12,
					"active": true,
					"size": 3,
					"tileIds": [93],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,-1,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 9946145,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 13,
					"active": true,
					"size": 3,
					"tileIds": [112],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7059799,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 14,
					"active": true,
					"size": 3,
					"tileIds": [111],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,-1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1040826,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 15,
					"active": true,
					"size": 3,
					"tileIds": [55],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 749291,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 16,
					"active": true,
					"size": 3,
					"tileIds": [54],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1765265,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 17,
					"active": true,
					"size": 3,
					"tileIds": [105],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,-1,1,1,0,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8462189,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 18,
					"active": true,
					"size": 3,
					"tileIds": [84],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6969674,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 19,
					"active": true,
					"size": 3,
					"tileIds": [52],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1051729,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 20,
					"active": true,
					"size": 3,
					"tileIds": [106],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,-1,1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8411509,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 21,
					"active": true,
					"size": 3,
					"tileIds": [83],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7069756,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 22,
					"active": true,
					"size": 3,
					"tileIds": [51],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6267117,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 23,
					"active": true,
					"size": 3,
					"tileIds": [102],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2264727,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 24,
					"active": true,
					"size": 3,
					"tileIds": [87],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,0,1,1,-1,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6780424,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 25,
					"active": true,
					"size": 3,
					"tileIds": [32],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4162103,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 26,
					"active": true,
					"size": 3,
					"tileIds": [86],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,1,-1,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8027629,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 27,
					"active": true,
					"size": 3,
					"tileIds": [103],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8106619,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 28,
					"active": true,
					"size": 3,
					"tileIds": [33],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8999356,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 29,
					"active": true,
					"size": 3,
					"tileIds": [109],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2183337,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 30,
					"active": true,
					"size": 3,
					"tileIds": [108],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,-1,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4363962,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 31,
					"active": true,
					"size": 3,
					"tileIds": [89],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7523429,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 32,
					"active": true,
					"size": 3,
					"tileIds": [90],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,-1,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8388116,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 33,
					"active": true,
					"size": 3,
					"tileIds": [29],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7211946,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 34,
					"active": true,
					"size": 3,
					"tileIds": [49],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7870440,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 35,
					"active": true,
					"size": 3,
					"tileIds": [48],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2155147,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 36,
					"active": true,
					"size": 3,
					"tileIds": [30],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2272273,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 37,
					"active": true,
					"size": 3,
					"tileIds": [96],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 734918,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 38,
					"active": true,
					"size": 3,
					"tileIds": [98],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6283682,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 39,
					"active": true,
					"size": 3,
					"tileIds": [97],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7753826,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 40,
					"active": true,
					"size": 3,
					"tileIds": [24],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5249268,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 41,
					"active": true,
					"size": 3,
					"tileIds": [62],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3307131,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 42,
					"active": true,
					"size": 3,
					"tileIds": [43],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4753767,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 43,
					"active": true,
					"size": 3,
					"tileIds": [20],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6111798,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 44,
					"active": true,
					"size": 3,
					"tileIds": [22],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5424485,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 45,
					"active": true,
					"size": 3,
					"tileIds": [60],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8718332,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 46,
					"active": true,
					"size": 3,
					"tileIds": [58],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8256814,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 47,
					"active": true,
					"size": 3,
					"tileIds": [21],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8307993,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 48,
					"active": true,
					"size": 3,
					"tileIds": [41],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 101116,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 49,
					"active": true,
					"size": 3,
					"tileIds": [59],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6710109,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 50,
					"active": true,
					"size": 3,
					"tileIds": [39],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4259795,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 51,
					"active": true,
					"size": 3,
					"tileIds": [46],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3292563,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 52,
					"active": true,
					"size": 3,
					"tileIds": [45],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,0,1,1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4620699,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 53,
					"active": true,
					"size": 3,
					"tileIds": [26],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 9995234,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 54,
					"active": true,
					"size": 3,
					"tileIds": [27],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,1,1,0,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 876601,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 55,
					"active": true,
					"size": 1,
					"tileIds": [40],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3132294,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				}
			], "usesWizard": true }],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": 1,
			"tilePivotX": 0,
			"tilePivotY": 0
		},
		{
			"__type": "Tiles",
			"identifier": "Decorations",
			"type": "Tiles",
			"uid": 106,
			"doc": null,
			"uiColor": null,
			"gridSize": 16,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 1,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": true,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": [],
			"excludedTags": [],
			"intGridValues": [],
			"intGridValuesGroups": [],
			"autoRuleGroups": [],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": 2,
			"tilePivotX": 0,
			"tilePivotY": 0
		},
		{
			"__type": "IntGrid",
			"identifier": "Background",
			"type": "IntGrid",
			"uid": 56,
			"doc": null,
			"uiColor": null,
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 1,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": true,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": [],
			"excludedTags": [],
			"intGridValues": [{ "value": 1, "identifier": null, "color": "#FFE700", "tile": null, "groupUid": 0 }],
			"intGridValuesGroups": [],
			"autoRuleGroups": [{ "uid": 57, "name": "Rules for #1", "color": null, "icon": null, "active": true, "isOptional": false, "rules": [
				{
					"uid": 58,
					"active": true,
					"size": 3,
					"tileIds": [214],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8152531,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 59,
					"active": true,
					"size": 3,
					"tileIds": [149],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6657364,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 60,
					"active": true,
					"size": 3,
					"tileIds": [206],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7875407,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 61,
					"active": true,
					"size": 3,
					"tileIds": [207],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,-1,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4364683,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 62,
					"active": true,
					"size": 3,
					"tileIds": [226],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6578162,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 63,
					"active": true,
					"size": 3,
					"tileIds": [225],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,-1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2464478,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 64,
					"active": true,
					"size": 3,
					"tileIds": [169],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5600038,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 65,
					"active": true,
					"size": 3,
					"tileIds": [168],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1806963,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 66,
					"active": true,
					"size": 3,
					"tileIds": [219],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,-1,1,1,0,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 9024837,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 67,
					"active": true,
					"size": 3,
					"tileIds": [198],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7604585,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 68,
					"active": true,
					"size": 3,
					"tileIds": [166],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5452661,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 69,
					"active": true,
					"size": 3,
					"tileIds": [220],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,-1,1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2405706,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 70,
					"active": true,
					"size": 3,
					"tileIds": [197],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8495395,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 71,
					"active": true,
					"size": 3,
					"tileIds": [165],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 9395568,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 72,
					"active": true,
					"size": 3,
					"tileIds": [216],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3825745,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 73,
					"active": true,
					"size": 3,
					"tileIds": [201],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,0,1,1,-1,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3542233,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 74,
					"active": true,
					"size": 3,
					"tileIds": [146],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4391767,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 75,
					"active": true,
					"size": 3,
					"tileIds": [200],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,1,-1,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1778342,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 76,
					"active": true,
					"size": 3,
					"tileIds": [217],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2755871,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 77,
					"active": true,
					"size": 3,
					"tileIds": [147],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 870259,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 78,
					"active": true,
					"size": 3,
					"tileIds": [223],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 2940323,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 79,
					"active": true,
					"size": 3,
					"tileIds": [222],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,-1,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 694738,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 80,
					"active": true,
					"size": 3,
					"tileIds": [203],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7386612,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 81,
					"active": true,
					"size": 3,
					"tileIds": [204],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,-1,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 554935,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 82,
					"active": true,
					"size": 3,
					"tileIds": [143],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,1,1,1,1,-1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8450801,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 83,
					"active": true,
					"size": 3,
					"tileIds": [163],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,-1,1,1,1,1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 142820,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 84,
					"active": true,
					"size": 3,
					"tileIds": [162],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1,1,1,1,1,1,-1,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5076185,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 85,
					"active": true,
					"size": 3,
					"tileIds": [144],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,-1,1,1,1,1,1,1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 844500,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 86,
					"active": true,
					"size": 3,
					"tileIds": [210],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5689883,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 87,
					"active": true,
					"size": 3,
					"tileIds": [212],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5808267,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 88,
					"active": true,
					"size": 3,
					"tileIds": [211],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4916911,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 89,
					"active": true,
					"size": 3,
					"tileIds": [138],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 8789643,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 90,
					"active": true,
					"size": 3,
					"tileIds": [176],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1551731,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 91,
					"active": true,
					"size": 3,
					"tileIds": [157],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5561747,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 92,
					"active": true,
					"size": 3,
					"tileIds": [134],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,-1,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1150937,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 93,
					"active": true,
					"size": 3,
					"tileIds": [136],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7793398,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 94,
					"active": true,
					"size": 3,
					"tileIds": [174],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,-1,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 5560633,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 95,
					"active": true,
					"size": 3,
					"tileIds": [172],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4175240,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 96,
					"active": true,
					"size": 3,
					"tileIds": [135],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,-1,0,0,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1077985,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 97,
					"active": true,
					"size": 3,
					"tileIds": [155],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,-1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 6198456,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 98,
					"active": true,
					"size": 3,
					"tileIds": [173],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,0,0,-1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 9621644,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 99,
					"active": true,
					"size": 3,
					"tileIds": [153],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,-1,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3131401,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 100,
					"active": true,
					"size": 3,
					"tileIds": [160],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [-1,1,0,1,1,0,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 4677725,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 101,
					"active": true,
					"size": 3,
					"tileIds": [159],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,1,-1,0,1,1,0,0,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1721006,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 102,
					"active": true,
					"size": 3,
					"tileIds": [140],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,0,1,1,0,1,-1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 1564172,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 103,
					"active": true,
					"size": 3,
					"tileIds": [141],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [0,0,0,1,1,0,-1,1,0],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 3318463,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				},
				{
					"uid": 104,
					"active": true,
					"size": 1,
					"tileIds": [154],
					"alpha": 1,
					"chance": 1,
					"breakOnMatch": true,
					"pattern": [1],
					"flipX": false,
					"flipY": false,
					"xModulo": 1,
					"yModulo": 1,
					"xOffset": 0,
					"yOffset": 0,
					"tileXOffset": 0,
					"tileYOffset": 0,
					"tileRandomXMin": 0,
					"tileRandomXMax": 0,
					"tileRandomYMin": 0,
					"tileRandomYMax": 0,
					"checker": "None",
					"tileMode": "Single",
					"pivotX": 0,
					"pivotY": 0,
					"outOfBoundsValue": 1,
					"perlinActive": false,
					"perlinSeed": 7957553,
					"perlinScale": 0.2,
					"perlinOctaves": 2
				}
			], "usesWizard": true }],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": 1,
			"tilePivotX": 0,
			"tilePivotY": 0
		}
	], "entities": [
		{
			"identifier": "Enemy",
			"uid": 6,
			"tags": [],
			"exportToToc": false,
			"doc": null,
			"width": 28,
			"height": 28,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#D77643",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 4,
			"tileRenderMode": "FitInside",
			"tileRect": { "tilesetUid": 4, "x": 0, "y": 0, "w": 26, "h": 26 },
			"uiTileRect": { "tilesetUid": 4, "x": 0, "y": 0, "w": 26, "h": 26 },
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": [
				{
					"identifier": "Direction",
					"doc": null,
					"__type": "LocalEnum.Direction",
					"uid": 112,
					"type": "F_Enum(111)",
					"isArray": false,
					"canBeNull": false,
					"arrayMinLength": null,
					"arrayMaxLength": null,
					"editorDisplayMode": "Hidden",
					"editorDisplayScale": 1,
					"editorDisplayPos": "Above",
					"editorLinkStyle": "StraightArrow",
					"editorDisplayColor": null,
					"editorAlwaysShow": false,
					"editorShowInWorld": true,
					"editorCutLongValues": true,
					"editorTextSuffix": null,
					"editorTextPrefix": null,
					"useForSmartColor": false,
					"min": null,
					"max": null,
					"regex": null,
					"acceptFileTypes": null,
					"defaultOverride": {
						"id": "V_String",
						"params": ["Left"]
					},
					"textLanguageMode": null,
					"symmetricalRef": false,
					"autoChainRef": true,
					"allowOutOfLevelRef": true,
					"allowedRefs": "OnlySame",
					"allowedRefsEntityUid": null,
					"allowedRefTags": [],
					"tilesetUid": null
				}
			]
		},
		{
			"identifier": "Enemy_King",
			"uid": 108,
			"tags": [],
			"exportToToc": false,
			"doc": null,
			"width": 16,
			"height": 16,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#EAD4AA",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 107,
			"tileRenderMode": "FitInside",
			"tileRect": { "tilesetUid": 107, "x": 43, "y": 0, "w": 28, "h": 28 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "Door",
			"uid": 110,
			"tags": [],
			"exportToToc": false,
			"doc": null,
			"width": 46,
			"height": 56,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#E4A672",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 109,
			"tileRenderMode": "FitInside",
			"tileRect": { "tilesetUid": 109, "x": 0, "y": 0, "w": 46, "h": 56 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 1,
			"fieldDefs": []
		},
		{
			"identifier": "Player",
			"uid": 5,
			"tags": [],
			"exportToToc": false,
			"doc": null,
			"width": 58,
			"height": 58,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#BE4A2F",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 3,
			"tileRenderMode": "FitInside",
			"tileRect": { "tilesetUid": 3, "x": 0, "y": 0, "w": 58, "h": 58 },
			"uiTileRect": { "tilesetUid": 3, "x": 0, "y": 0, "w": 58, "h": 58 },
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		}
	], "tilesets": [
		{
			"__cWid": 19,
			"__cHei": 13,
			"identifier": "Terrain",
			"uid": 1,
			"relPath": "../sprites/14-tilesets/terrain_(32x32).png",
			"embedAtlas": null,
			"pxWid": 608,
			"pxHei": 416,
			"tileGridSize": 32,
			"spacing": 0,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": {
				"opaqueTiles": "0000000000000000000011101011011011010001110101101101101100111010000000000000000000011011011011001110101101101101100000000000000000000011101011011011010001110101101101101100111010000000000000000000011011011011001110101101101101100000000000000000000",
				"averageColors": "00000000000000000000000000000000000000000000000000000000000000000000000000000000fa76f966fa760000fb870000f755f7550000f855f8550000f965f9550000f966000000000000f966f435f9660000fb760000f755f7450000f855f8550000f955f9550000f955f95500000000fa76f966fa760000fb8700000000000000000000000000000000000000000000000000000000000000000000000000000000f966f9660000f966f9660000fa76fa760000fb76fb7600000000fb87fb76fb870000fb870000f966f9660000fa66fa660000fa76fa760000fa76fb76000000000000000000000000000000000000000000000000000000000000000000000000000000000000f977fa88f9770000f9670000fb88fb880000fb88fa880000fa88fa880000fa88000000000000fa78fb88fa780000f9770000fb88fb880000fb88fb880000fa88fa880000fb88fb8800000000fa77fa88fa770000f96700000000000000000000000000000000000000000000000000000000000000000000000000000000fa78fa780000fa77fa770000fa78fa770000f977f97700000000f977fa77f9770000f8670000fa88fa880000fa77fa770000fa77fa780000f977f97700000000000000000000000000000000000000000000000000000000000000000000000000000000"
			}
		},
		{
			"__cWid": 7,
			"__cHei": 6,
			"identifier": "Decorations",
			"uid": 2,
			"relPath": "../sprites/14-tilesets/decorations_(32x32).png",
			"embedAtlas": null,
			"pxWid": 224,
			"pxHei": 192,
			"tileGridSize": 32,
			"spacing": 0,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": {
				"opaqueTiles": "000000000000000000000000000000000000000000",
				"averageColors": "00000000000000000000000000000000c999386638663866386600000000c9aa79887a77797868880000000089aa8bbb4cbb8bbb4cbb0000000079aa6bbb4cbb6bbb4cbb00000000000000000000000000000000"
			}
		},
		{
			"__cWid": 11,
			"__cHei": 1,
			"identifier": "Player",
			"uid": 3,
			"relPath": "../sprites/01-king_human/idle_(78x58).png",
			"embedAtlas": null,
			"pxWid": 858,
			"pxHei": 58,
			"tileGridSize": 58,
			"spacing": 20,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": { "opaqueTiles": "00000000000", "averageColors": "39773977397739773977397739773977397739773977" }
		},
		{
			"__cWid": 10,
			"__cHei": 1,
			"identifier": "Enemy",
			"uid": 4,
			"relPath": "../sprites/05-pig_thowing_a_bomb/idle_(26x26).png",
			"embedAtlas": null,
			"pxWid": 260,
			"pxHei": 26,
			"tileGridSize": 26,
			"spacing": 0,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": { "opaqueTiles": "0000000000", "averageColors": "6588758875887688668876887688768876887688" }
		},
		{
			"__cWid": 11,
			"__cHei": 1,
			"identifier": "Enemy_King",
			"uid": 107,
			"relPath": "../sprites/02-king_pig/idle_(38x28).png",
			"embedAtlas": null,
			"pxWid": 456,
			"pxHei": 28,
			"tileGridSize": 28,
			"spacing": 15,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": { "opaqueTiles": "00000000001", "averageColors": "57875787578747873687267737885798668767870000" }
		},
		{
			"__cWid": 23,
			"__cHei": 28,
			"identifier": "Door_Idle",
			"uid": 109,
			"relPath": "../sprites/11-door/idle.png",
			"embedAtlas": null,
			"pxWid": 46,
			"pxHei": 56,
			"tileGridSize": 2,
			"spacing": 0,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": {
				"opaqueTiles": "00000111111111111100000000111111111111111110000011111111111111111110001111111111111111111110011111111111111111111101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111",
				"averageColors": "0000000000004656ba88f977fb98fb98fba9fbaafb98f977fb98fba9fba9fbaafb98f977ba88465600000000000000000000ba77fdbaffcafb98ffcaffcaffcaffcaffcafb98ffcaffcaffcaffcaffcafb98ffcafdbaba77000000000000ba77ffcbffcafeb9fb77fea9fea9fea9fea9fea9fb77fea9fea9fea9fea9fea9fb77feb9ffcaffcbba7700004656fda9ffcafea9fc78f866f867f867f867f867f756f667f656f867f867f867f867f866fc78fea9ffcafda94656ba77ffcaffbafc78f656f756f867f867f867f867f866f667f656f867f867f867f867f756f656fc78ffbaffcaba77fb98ffcafea9f967f967fa77fb88fb88fb88fb78f867f667f656f967f977f977f977f977f867f967fea9ffcafb98f977fb98fb77f656f867f977f977f977f977f977f866f667f656f977f977f977f977f977f867f656fb77fb98f977fb98ffcafea9f667f667fa78fb98fb98fb98fb98fb88f667f977fb98fb98fb98fb98fa78f667f667fea9ffcafb98fbaaffcafea9f767f778fa78fb98fb98fb98fb98fb98f778f977fb98fb98fb98fb98fa78f778f767fea9ffcafbaafba9ffcafea9f866f977f977f977f977f977f977f977f788f866f977f977f977f977f977f977f866fea9ffcafba9fb98ffcafea9f756f867f867f867f867f867f867f867f778f977fb98fb98fb98fb98fb98fb98f977fea9ffcafb98fb98ffcafea9f867fa77fa77fa77fa77fa77fa77fa67f778f977fb98fb98fb98fb98fb98fb98f977fea9ffcafb98f977fb98fb77f866f977f977f977f977f977f977f977f667f866f977f977f977f977f977f977f866fb77fb98f977fba9ffcafea9f977fb98fb98fb98fb98fb98fb98fa78f667f867fb88fb98fb98fb98fb98fb98f977fea9ffcafba9fba9ffcafea9f866f977f977f977f977f977f977f778f788f89af866f977f977f977f977f977f866fea9ffcafba9fba9ffcafea9f656f867f867f867f867f867f867f778f788f799f977fb98fb98fb98fb98fb98f977fea9ffcafba9fb98ffcafea9f656fa67fa77fa77fa77fa77fa67f778f788f799f977fb98fb98fb98fb98fb98f977fea9ffcafb98f977fb98fb77f866f977f977f977f977f977f977f778f788f799f656f656f656f656f656f656f656fb77fb98f977fb98ffcafea9f977fb98fb98fb98fb98fb98fb98f778f788f799f867fa77fa77fa77fa77fa67f656fea9ffcafb98fbaaffcafea9f866f977f977f977f977f977f977f778f788f799f756f867f867f867f867f867f656fea9ffcafbaafba9ffcafea9f866f977fb88fb98fb98fb98fb88f767f778f778fa77fb98fb98fb98fb88f977f867fea9ffcafba9fb98ffcafea9f667f789f977fb98fb98fb98fb98fb88f667f977fb98fb98fb98fb98f977f789f667fea9ffcafb98fb98ffcafea9f656f656f977f977f977f977f977f977f778f867f977f977f977f977f977f656f656fea9ffcafb98f977fb98fb77f867fa77fa77fa77fa77fa77fa77f867f667f977fb98fb98fb98fb98fb98fb98f977fb77fb98f977fba9ffcafea9f756f867f867f867f867f867f867f756f667f977fb98fb98fb98fb98fb98fb98f977fea9ffcafba9fba9ffcafea9f866f977f977f977f977f977f977f977f667f656f656f656f656f656f656f656f656fea9ffcafba9fb77fea9fd88f977fb98fb98fb98fb98fb98fb98fb88f667f656fa67fa77fa77fa77fa77fa67f656fd88fea9fb77f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656f656"
			}
		}
	], "enums": [{ "identifier": "Direction", "uid": 111, "values": [ { "id": "Left", "tileRect": null, "color": 12470831 }, { "id": "Right", "tileRect": null, "color": 14120515 } ], "iconTilesetUid": null, "externalRelPath": null, "externalFileChecksum": null, "tags": [] }], "externalEnums": [], "levelFields": [] },
	"levels": [
		{
			"identifier": "Level_0",
			"iid": "3e1dcd50-6280-11ee-862e-4f47d61c1814",
			"uid": 0,
			"worldX": 0,
			"worldY": 0,
			"worldDepth": 0,
			"pxWid": 640,
			"pxHei": 352,
			"__bgColor": "#3F3851",
			"bgColor": "#3F3851",
			"useAutoIdentifier": true,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#95929F",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "Entities",
					"__type": "Entities",
					"__cWid": 20,
					"__cHei": 11,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "809d16b0-6280-11ee-862e-2fce892b1b6e",
					"levelId": 0,
					"layerDefUid": 105,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 9866811,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Enemy",
							"__grid": [19,3],
							"__pivot": [0.5,0.5],
							"__tags": [],
							"__tile": { "tilesetUid": 4, "x": 0, "y": 0, "w": 26, "h": 26 },
							"__smartColor": "#D77643",
							"__worldX": 624,
							"__worldY": 112,
							"iid": "672803c0-6280-11ee-862e-bd3657aa2cda",
							"width": 28,
							"height": 28,
							"defUid": 6,
							"px": [624,112],
							"fieldInstances": [{ "__identifier": "Direction", "__type": "LocalEnum.Direction", "__value": "Left", "__tile": null, "defUid": 112, "realEditorValues": [] }]
						},
						{
							"__identifier": "Enemy",
							"__grid": [0,3],
							"__pivot": [0.5,0.5],
							"__tags": [],
							"__tile": { "tilesetUid": 4, "x": 0, "y": 0, "w": 26, "h": 26 },
							"__smartColor": "#D77643",
							"__worldX": 16,
							"__worldY": 112,
							"iid": "6c021480-6280-11ee-862e-0b7266971c32",
							"width": 28,
							"height": 28,
							"defUid": 6,
							"px": [16,112],
							"fieldInstances": [{ "__identifier": "Direction", "__type": "LocalEnum.Direction", "__value": "Right", "__tile": null, "defUid": 112, "realEditorValues": [{
								"id": "V_String",
								"params": ["Right"]
							}] }]
						},
						{
							"__identifier": "Player",
							"__grid": [9,8],
							"__pivot": [0.5,0.5],
							"__tags": [],
							"__tile": { "tilesetUid": 3, "x": 0, "y": 0, "w": 58, "h": 58 },
							"__smartColor": "#BE4A2F",
							"__worldX": 304,
							"__worldY": 272,
							"iid": "1e68acd0-6280-11ee-862e-d933d0fa09ba",
							"width": 58,
							"height": 58,
							"defUid": 5,
							"px": [304,272],
							"fieldInstances": []
						},
						{
							"__identifier": "Enemy",
							"__grid": [10,3],
							"__pivot": [0.5,0.5],
							"__tags": [],
							"__tile": { "tilesetUid": 4, "x": 0, "y": 0, "w": 26, "h": 26 },
							"__smartColor": "#D77643",
							"__worldX": 336,
							"__worldY": 112,
							"iid": "e4ce09f0-6280-11ee-a008-bfb94c6ed7ea",
							"width": 28,
							"height": 28,
							"defUid": 6,
							"px": [336,112],
							"fieldInstances": [{ "__identifier": "Direction", "__type": "LocalEnum.Direction", "__value": "Right", "__tile": null, "defUid": 112, "realEditorValues": [{
								"id": "V_String",
								"params": ["Right"]
							}] }]
						},
						{
							"__identifier": "Enemy",
							"__grid": [8,3],
							"__pivot": [0.5,0.5],
							"__tags": [],
							"__tile": { "tilesetUid": 4, "x": 0, "y": 0, "w": 26, "h": 26 },
							"__smartColor": "#D77643",
							"__worldX": 272,
							"__worldY": 112,
							"iid": "e55b2ec0-6280-11ee-a008-4ff5bb26eb7e",
							"width": 28,
							"height": 28,
							"defUid": 6,
							"px": [272,112],
							"fieldInstances": [{ "__identifier": "Direction", "__type": "LocalEnum.Direction", "__value": "Left", "__tile": null, "defUid": 112, "realEditorValues": [] }]
						}
					]
				},
				{
					"__identifier": "Terrain",
					"__type": "IntGrid",
					"__cWid": 20,
					"__cHei": 11,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": 1,
					"__tilesetRelPath": "../sprites/14-tilesets/terrain_(32x32).png",
					"iid": "0778c780-6280-11ee-862e-1785cfb36efa",
					"levelId": 0,
					"layerDefUid": 7,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [
						1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
						0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,
						0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,
						0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,
						1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,
						0,1,0,0,1,1,1,1,1,1,1,0,0,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
						1,1,1,1,1,1,1,1,1,1
					],
					"autoLayerTiles": [
						{ "px": [0,256], "src": [64,64], "f": 0, "t": 40, "d": [55,160], "a": 1 },
						{ "px": [0,288], "src": [64,64], "f": 0, "t": 40, "d": [55,180], "a": 1 },
						{ "px": [32,288], "src": [64,64], "f": 0, "t": 40, "d": [55,181], "a": 1 },
						{ "px": [64,288], "src": [64,64], "f": 0, "t": 40, "d": [55,182], "a": 1 },
						{ "px": [0,320], "src": [64,64], "f": 0, "t": 40, "d": [55,200], "a": 1 },
						{ "px": [32,320], "src": [64,64], "f": 0, "t": 40, "d": [55,201], "a": 1 },
						{ "px": [64,320], "src": [64,64], "f": 0, "t": 40, "d": [55,202], "a": 1 },
						{ "px": [96,320], "src": [64,64], "f": 0, "t": 40, "d": [55,203], "a": 1 },
						{ "px": [128,320], "src": [64,64], "f": 0, "t": 40, "d": [55,204], "a": 1 },
						{ "px": [288,320], "src": [64,64], "f": 0, "t": 40, "d": [55,209], "a": 1 },
						{ "px": [512,320], "src": [64,64], "f": 0, "t": 40, "d": [55,216], "a": 1 },
						{ "px": [544,320], "src": [64,64], "f": 0, "t": 40, "d": [55,217], "a": 1 },
						{ "px": [576,320], "src": [64,64], "f": 0, "t": 40, "d": [55,218], "a": 1 },
						{ "px": [608,320], "src": [64,64], "f": 0, "t": 40, "d": [55,219], "a": 1 },
						{ "px": [608,0], "src": [256,32], "f": 0, "t": 27, "d": [54,19], "a": 1 },
						{ "px": [0,0], "src": [224,32], "f": 0, "t": 26, "d": [53,0], "a": 1 },
						{ "px": [0,224], "src": [224,64], "f": 0, "t": 45, "d": [52,140], "a": 1 },
						{ "px": [32,256], "src": [224,64], "f": 0, "t": 45, "d": [52,161], "a": 1 },
						{ "px": [96,288], "src": [224,64], "f": 0, "t": 45, "d": [52,183], "a": 1 },
						{ "px": [160,320], "src": [224,64], "f": 0, "t": 45, "d": [52,205], "a": 1 },
						{ "px": [320,320], "src": [224,64], "f": 0, "t": 45, "d": [52,210], "a": 1 },
						{ "px": [608,288], "src": [256,64], "f": 0, "t": 46, "d": [51,199], "a": 1 },
						{ "px": [256,320], "src": [256,64], "f": 0, "t": 46, "d": [51,208], "a": 1 },
						{ "px": [480,320], "src": [256,64], "f": 0, "t": 46, "d": [51,215], "a": 1 },
						{ "px": [608,32], "src": [32,64], "f": 0, "t": 39, "d": [50,39], "a": 1 },
						{ "px": [608,160], "src": [32,64], "f": 0, "t": 39, "d": [50,119], "a": 1 },
						{ "px": [608,192], "src": [32,64], "f": 0, "t": 39, "d": [50,139], "a": 1 },
						{ "px": [608,224], "src": [32,64], "f": 0, "t": 39, "d": [50,159], "a": 1 },
						{ "px": [608,256], "src": [32,64], "f": 0, "t": 39, "d": [50,179], "a": 1 },
						{ "px": [32,0], "src": [64,96], "f": 0, "t": 59, "d": [49,1], "a": 1 },
						{ "px": [64,0], "src": [64,96], "f": 0, "t": 59, "d": [49,2], "a": 1 },
						{ "px": [96,0], "src": [64,96], "f": 0, "t": 59, "d": [49,3], "a": 1 },
						{ "px": [128,0], "src": [64,96], "f": 0, "t": 59, "d": [49,4], "a": 1 },
						{ "px": [160,0], "src": [64,96], "f": 0, "t": 59, "d": [49,5], "a": 1 },
						{ "px": [192,0], "src": [64,96], "f": 0, "t": 59, "d": [49,6], "a": 1 },
						{ "px": [224,0], "src": [64,96], "f": 0, "t": 59, "d": [49,7], "a": 1 },
						{ "px": [256,0], "src": [64,96], "f": 0, "t": 59, "d": [49,8], "a": 1 },
						{ "px": [288,0], "src": [64,96], "f": 0, "t": 59, "d": [49,9], "a": 1 },
						{ "px": [320,0], "src": [64,96], "f": 0, "t": 59, "d": [49,10], "a": 1 },
						{ "px": [352,0], "src": [64,96], "f": 0, "t": 59, "d": [49,11], "a": 1 },
						{ "px": [384,0], "src": [64,96], "f": 0, "t": 59, "d": [49,12], "a": 1 },
						{ "px": [416,0], "src": [64,96], "f": 0, "t": 59, "d": [49,13], "a": 1 },
						{ "px": [448,0], "src": [64,96], "f": 0, "t": 59, "d": [49,14], "a": 1 },
						{ "px": [480,0], "src": [64,96], "f": 0, "t": 59, "d": [49,15], "a": 1 },
						{ "px": [512,0], "src": [64,96], "f": 0, "t": 59, "d": [49,16], "a": 1 },
						{ "px": [544,0], "src": [64,96], "f": 0, "t": 59, "d": [49,17], "a": 1 },
						{ "px": [576,0], "src": [64,96], "f": 0, "t": 59, "d": [49,18], "a": 1 },
						{ "px": [0,32], "src": [96,64], "f": 0, "t": 41, "d": [48,20], "a": 1 },
						{ "px": [0,160], "src": [96,64], "f": 0, "t": 41, "d": [48,100], "a": 1 },
						{ "px": [0,192], "src": [96,64], "f": 0, "t": 41, "d": [48,120], "a": 1 },
						{ "px": [64,256], "src": [64,32], "f": 0, "t": 21, "d": [47,162], "a": 1 },
						{ "px": [128,288], "src": [64,32], "f": 0, "t": 21, "d": [47,184], "a": 1 },
						{ "px": [288,288], "src": [64,32], "f": 0, "t": 21, "d": [47,189], "a": 1 },
						{ "px": [544,288], "src": [64,32], "f": 0, "t": 21, "d": [47,197], "a": 1 },
						{ "px": [576,288], "src": [64,32], "f": 0, "t": 21, "d": [47,198], "a": 1 },
						{ "px": [192,320], "src": [64,32], "f": 0, "t": 21, "d": [47,206], "a": 1 },
						{ "px": [224,320], "src": [64,32], "f": 0, "t": 21, "d": [47,207], "a": 1 },
						{ "px": [352,320], "src": [64,32], "f": 0, "t": 21, "d": [47,211], "a": 1 },
						{ "px": [384,320], "src": [64,32], "f": 0, "t": 21, "d": [47,212], "a": 1 },
						{ "px": [416,320], "src": [64,32], "f": 0, "t": 21, "d": [47,213], "a": 1 },
						{ "px": [448,320], "src": [64,32], "f": 0, "t": 21, "d": [47,214], "a": 1 },
						{ "px": [608,64], "src": [32,96], "f": 0, "t": 58, "d": [46,59], "a": 1 },
						{ "px": [0,64], "src": [96,96], "f": 0, "t": 60, "d": [45,40], "a": 1 },
						{ "px": [0,128], "src": [96,32], "f": 0, "t": 22, "d": [44,80], "a": 1 },
						{ "px": [32,224], "src": [96,32], "f": 0, "t": 22, "d": [44,141], "a": 1 },
						{ "px": [96,256], "src": [96,32], "f": 0, "t": 22, "d": [44,163], "a": 1 },
						{ "px": [160,288], "src": [96,32], "f": 0, "t": 22, "d": [44,185], "a": 1 },
						{ "px": [320,288], "src": [96,32], "f": 0, "t": 22, "d": [44,190], "a": 1 },
						{ "px": [608,128], "src": [32,32], "f": 0, "t": 20, "d": [43,99], "a": 1 },
						{ "px": [256,288], "src": [32,32], "f": 0, "t": 20, "d": [43,188], "a": 1 },
						{ "px": [480,288], "src": [32,32], "f": 0, "t": 20, "d": [43,195], "a": 1 },
						{ "px": [512,256], "src": [160,32], "f": 0, "t": 24, "d": [40,176], "a": 1 },
						{ "px": [512,288], "src": [352,32], "f": 0, "t": 30, "d": [36,196], "a": 1 }
					],
					"seed": 8934606,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "Decorations",
					"__type": "Tiles",
					"__cWid": 40,
					"__cHei": 22,
					"__gridSize": 16,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": 2,
					"__tilesetRelPath": "../sprites/14-tilesets/decorations_(32x32).png",
					"iid": "8d02eab0-6280-11ee-862e-e9b70c95a32a",
					"levelId": 0,
					"layerDefUid": 106,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 2138829,
					"overrideTilesetUid": null,
					"gridTiles": [
						{ "px": [80,64], "src": [64,96], "f": 0, "t": 23, "d": [165], "a": 1 },
						{ "px": [112,64], "src": [96,96], "f": 0, "t": 24, "d": [167], "a": 1 },
						{ "px": [512,64], "src": [160,96], "f": 1, "t": 26, "d": [192], "a": 1 },
						{ "px": [544,64], "src": [128,96], "f": 1, "t": 25, "d": [194], "a": 1 },
						{ "px": [80,96], "src": [64,128], "f": 0, "t": 30, "d": [245], "a": 1 },
						{ "px": [112,96], "src": [96,128], "f": 0, "t": 31, "d": [247], "a": 1 },
						{ "px": [512,96], "src": [160,128], "f": 1, "t": 33, "d": [272], "a": 1 },
						{ "px": [544,96], "src": [128,128], "f": 1, "t": 32, "d": [274], "a": 1 },
						{ "px": [256,128], "src": [64,32], "f": 0, "t": 9, "d": [336], "a": 1 },
						{ "px": [288,128], "src": [96,32], "f": 0, "t": 10, "d": [338], "a": 1 },
						{ "px": [320,128], "src": [128,32], "f": 0, "t": 11, "d": [340], "a": 1 },
						{ "px": [256,160], "src": [32,32], "f": 0, "t": 8, "d": [416], "a": 1 },
						{ "px": [320,160], "src": [32,32], "f": 0, "t": 8, "d": [420], "a": 1 },
						{ "px": [256,192], "src": [32,64], "f": 0, "t": 15, "d": [496], "a": 1 },
						{ "px": [288,192], "src": [32,32], "f": 0, "t": 8, "d": [498], "a": 1 },
						{ "px": [320,192], "src": [32,64], "f": 0, "t": 15, "d": [500], "a": 1 },
						{ "px": [256,224], "src": [32,128], "f": 0, "t": 29, "d": [576], "a": 1 },
						{ "px": [288,224], "src": [32,64], "f": 0, "t": 15, "d": [578], "a": 1 },
						{ "px": [320,224], "src": [32,128], "f": 0, "t": 29, "d": [580], "a": 1 },
						{ "px": [288,256], "src": [32,96], "f": 0, "t": 22, "d": [658], "a": 1 }
					],
					"entityInstances": []
				},
				{
					"__identifier": "Background",
					"__type": "IntGrid",
					"__cWid": 20,
					"__cHei": 11,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": 1,
					"__tilesetRelPath": "../sprites/14-tilesets/terrain_(32x32).png",
					"iid": "c41318f0-6280-11ee-862e-e92536353195",
					"levelId": 0,
					"layerDefUid": 56,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [
						0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
						1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,
						1,1,1,1,1,1,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,
						1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,
						0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,
						1,0,1,1,0,0,0,0,0,0,0,1,1,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
						0,0,0,0,0,0,0,0,0,0
					],
					"autoLayerTiles": [
						{ "px": [64,64], "src": [64,256], "f": 0, "t": 154, "d": [104,42], "a": 1 },
						{ "px": [96,64], "src": [64,256], "f": 0, "t": 154, "d": [104,43], "a": 1 },
						{ "px": [128,64], "src": [64,256], "f": 0, "t": 154, "d": [104,44], "a": 1 },
						{ "px": [160,64], "src": [64,256], "f": 0, "t": 154, "d": [104,45], "a": 1 },
						{ "px": [192,64], "src": [64,256], "f": 0, "t": 154, "d": [104,46], "a": 1 },
						{ "px": [224,64], "src": [64,256], "f": 0, "t": 154, "d": [104,47], "a": 1 },
						{ "px": [256,64], "src": [64,256], "f": 0, "t": 154, "d": [104,48], "a": 1 },
						{ "px": [288,64], "src": [64,256], "f": 0, "t": 154, "d": [104,49], "a": 1 },
						{ "px": [320,64], "src": [64,256], "f": 0, "t": 154, "d": [104,50], "a": 1 },
						{ "px": [352,64], "src": [64,256], "f": 0, "t": 154, "d": [104,51], "a": 1 },
						{ "px": [384,64], "src": [64,256], "f": 0, "t": 154, "d": [104,52], "a": 1 },
						{ "px": [416,64], "src": [64,256], "f": 0, "t": 154, "d": [104,53], "a": 1 },
						{ "px": [448,64], "src": [64,256], "f": 0, "t": 154, "d": [104,54], "a": 1 },
						{ "px": [480,64], "src": [64,256], "f": 0, "t": 154, "d": [104,55], "a": 1 },
						{ "px": [512,64], "src": [64,256], "f": 0, "t": 154, "d": [104,56], "a": 1 },
						{ "px": [544,64], "src": [64,256], "f": 0, "t": 154, "d": [104,57], "a": 1 },
						{ "px": [64,96], "src": [64,256], "f": 0, "t": 154, "d": [104,62], "a": 1 },
						{ "px": [96,96], "src": [64,256], "f": 0, "t": 154, "d": [104,63], "a": 1 },
						{ "px": [128,96], "src": [64,256], "f": 0, "t": 154, "d": [104,64], "a": 1 },
						{ "px": [160,96], "src": [64,256], "f": 0, "t": 154, "d": [104,65], "a": 1 },
						{ "px": [192,96], "src": [64,256], "f": 0, "t": 154, "d": [104,66], "a": 1 },
						{ "px": [224,96], "src": [64,256], "f": 0, "t": 154, "d": [104,67], "a": 1 },
						{ "px": [256,96], "src": [64,256], "f": 0, "t": 154, "d": [104,68], "a": 1 },
						{ "px": [288,96], "src": [64,256], "f": 0, "t": 154, "d": [104,69], "a": 1 },
						{ "px": [320,96], "src": [64,256], "f": 0, "t": 154, "d": [104,70], "a": 1 },
						{ "px": [352,96], "src": [64,256], "f": 0, "t": 154, "d": [104,71], "a": 1 },
						{ "px": [384,96], "src": [64,256], "f": 0, "t": 154, "d": [104,72], "a": 1 },
						{ "px": [416,96], "src": [64,256], "f": 0, "t": 154, "d": [104,73], "a": 1 },
						{ "px": [448,96], "src": [64,256], "f": 0, "t": 154, "d": [104,74], "a": 1 },
						{ "px": [480,96], "src": [64,256], "f": 0, "t": 154, "d": [104,75], "a": 1 },
						{ "px": [512,96], "src": [64,256], "f": 0, "t": 154, "d": [104,76], "a": 1 },
						{ "px": [544,96], "src": [64,256], "f": 0, "t": 154, "d": [104,77], "a": 1 },
						{ "px": [64,128], "src": [64,256], "f": 0, "t": 154, "d": [104,82], "a": 1 },
						{ "px": [96,128], "src": [64,256], "f": 0, "t": 154, "d": [104,83], "a": 1 },
						{ "px": [128,128], "src": [64,256], "f": 0, "t": 154, "d": [104,84], "a": 1 },
						{ "px": [160,128], "src": [64,256], "f": 0, "t": 154, "d": [104,85], "a": 1 },
						{ "px": [192,128], "src": [64,256], "f": 0, "t": 154, "d": [104,86], "a": 1 },
						{ "px": [224,128], "src": [64,256], "f": 0, "t": 154, "d": [104,87], "a": 1 },
						{ "px": [256,128], "src": [64,256], "f": 0, "t": 154, "d": [104,88], "a": 1 },
						{ "px": [288,128], "src": [64,256], "f": 0, "t": 154, "d": [104,89], "a": 1 },
						{ "px": [320,128], "src": [64,256], "f": 0, "t": 154, "d": [104,90], "a": 1 },
						{ "px": [352,128], "src": [64,256], "f": 0, "t": 154, "d": [104,91], "a": 1 },
						{ "px": [384,128], "src": [64,256], "f": 0, "t": 154, "d": [104,92], "a": 1 },
						{ "px": [416,128], "src": [64,256], "f": 0, "t": 154, "d": [104,93], "a": 1 },
						{ "px": [448,128], "src": [64,256], "f": 0, "t": 154, "d": [104,94], "a": 1 },
						{ "px": [480,128], "src": [64,256], "f": 0, "t": 154, "d": [104,95], "a": 1 },
						{ "px": [512,128], "src": [64,256], "f": 0, "t": 154, "d": [104,96], "a": 1 },
						{ "px": [544,128], "src": [64,256], "f": 0, "t": 154, "d": [104,97], "a": 1 },
						{ "px": [64,160], "src": [64,256], "f": 0, "t": 154, "d": [104,102], "a": 1 },
						{ "px": [96,160], "src": [64,256], "f": 0, "t": 154, "d": [104,103], "a": 1 },
						{ "px": [128,160], "src": [64,256], "f": 0, "t": 154, "d": [104,104], "a": 1 },
						{ "px": [160,160], "src": [64,256], "f": 0, "t": 154, "d": [104,105], "a": 1 },
						{ "px": [192,160], "src": [64,256], "f": 0, "t": 154, "d": [104,106], "a": 1 },
						{ "px": [224,160], "src": [64,256], "f": 0, "t": 154, "d": [104,107], "a": 1 },
						{ "px": [256,160], "src": [64,256], "f": 0, "t": 154, "d": [104,108], "a": 1 },
						{ "px": [288,160], "src": [64,256], "f": 0, "t": 154, "d": [104,109], "a": 1 },
						{ "px": [320,160], "src": [64,256], "f": 0, "t": 154, "d": [104,110], "a": 1 },
						{ "px": [352,160], "src": [64,256], "f": 0, "t": 154, "d": [104,111], "a": 1 },
						{ "px": [384,160], "src": [64,256], "f": 0, "t": 154, "d": [104,112], "a": 1 },
						{ "px": [416,160], "src": [64,256], "f": 0, "t": 154, "d": [104,113], "a": 1 },
						{ "px": [448,160], "src": [64,256], "f": 0, "t": 154, "d": [104,114], "a": 1 },
						{ "px": [480,160], "src": [64,256], "f": 0, "t": 154, "d": [104,115], "a": 1 },
						{ "px": [512,160], "src": [64,256], "f": 0, "t": 154, "d": [104,116], "a": 1 },
						{ "px": [544,160], "src": [64,256], "f": 0, "t": 154, "d": [104,117], "a": 1 },
						{ "px": [96,192], "src": [64,256], "f": 0, "t": 154, "d": [104,123], "a": 1 },
						{ "px": [128,192], "src": [64,256], "f": 0, "t": 154, "d": [104,124], "a": 1 },
						{ "px": [160,192], "src": [64,256], "f": 0, "t": 154, "d": [104,125], "a": 1 },
						{ "px": [192,192], "src": [64,256], "f": 0, "t": 154, "d": [104,126], "a": 1 },
						{ "px": [224,192], "src": [64,256], "f": 0, "t": 154, "d": [104,127], "a": 1 },
						{ "px": [256,192], "src": [64,256], "f": 0, "t": 154, "d": [104,128], "a": 1 },
						{ "px": [288,192], "src": [64,256], "f": 0, "t": 154, "d": [104,129], "a": 1 },
						{ "px": [320,192], "src": [64,256], "f": 0, "t": 154, "d": [104,130], "a": 1 },
						{ "px": [352,192], "src": [64,256], "f": 0, "t": 154, "d": [104,131], "a": 1 },
						{ "px": [384,192], "src": [64,256], "f": 0, "t": 154, "d": [104,132], "a": 1 },
						{ "px": [416,192], "src": [64,256], "f": 0, "t": 154, "d": [104,133], "a": 1 },
						{ "px": [448,192], "src": [64,256], "f": 0, "t": 154, "d": [104,134], "a": 1 },
						{ "px": [480,192], "src": [64,256], "f": 0, "t": 154, "d": [104,135], "a": 1 },
						{ "px": [512,192], "src": [64,256], "f": 0, "t": 154, "d": [104,136], "a": 1 },
						{ "px": [544,192], "src": [64,256], "f": 0, "t": 154, "d": [104,137], "a": 1 },
						{ "px": [160,224], "src": [64,256], "f": 0, "t": 154, "d": [104,145], "a": 1 },
						{ "px": [192,224], "src": [64,256], "f": 0, "t": 154, "d": [104,146], "a": 1 },
						{ "px": [224,224], "src": [64,256], "f": 0, "t": 154, "d": [104,147], "a": 1 },
						{ "px": [256,224], "src": [64,256], "f": 0, "t": 154, "d": [104,148], "a": 1 },
						{ "px": [288,224], "src": [64,256], "f": 0, "t": 154, "d": [104,149], "a": 1 },
						{ "px": [320,224], "src": [64,256], "f": 0, "t": 154, "d": [104,150], "a": 1 },
						{ "px": [352,224], "src": [64,256], "f": 0, "t": 154, "d": [104,151], "a": 1 },
						{ "px": [384,224], "src": [64,256], "f": 0, "t": 154, "d": [104,152], "a": 1 },
						{ "px": [416,224], "src": [64,256], "f": 0, "t": 154, "d": [104,153], "a": 1 },
						{ "px": [448,224], "src": [64,256], "f": 0, "t": 154, "d": [104,154], "a": 1 },
						{ "px": [384,256], "src": [64,256], "f": 0, "t": 154, "d": [104,172], "a": 1 },
						{ "px": [416,256], "src": [64,256], "f": 0, "t": 154, "d": [104,173], "a": 1 },
						{ "px": [64,192], "src": [256,224], "f": 0, "t": 141, "d": [103,122], "a": 1 },
						{ "px": [128,224], "src": [256,224], "f": 0, "t": 141, "d": [103,144], "a": 1 },
						{ "px": [544,224], "src": [256,224], "f": 0, "t": 141, "d": [103,157], "a": 1 },
						{ "px": [192,256], "src": [256,224], "f": 0, "t": 141, "d": [103,166], "a": 1 },
						{ "px": [352,256], "src": [256,224], "f": 0, "t": 141, "d": [103,171], "a": 1 },
						{ "px": [480,224], "src": [224,224], "f": 0, "t": 140, "d": [102,155], "a": 1 },
						{ "px": [224,256], "src": [224,224], "f": 0, "t": 140, "d": [102,167], "a": 1 },
						{ "px": [448,256], "src": [224,224], "f": 0, "t": 140, "d": [102,174], "a": 1 },
						{ "px": [32,64], "src": [32,256], "f": 0, "t": 153, "d": [99,41], "a": 1 },
						{ "px": [32,128], "src": [32,256], "f": 0, "t": 153, "d": [99,81], "a": 1 },
						{ "px": [32,160], "src": [32,256], "f": 0, "t": 153, "d": [99,101], "a": 1 },
						{ "px": [96,224], "src": [64,288], "f": 0, "t": 173, "d": [98,143], "a": 1 },
						{ "px": [512,224], "src": [64,288], "f": 0, "t": 173, "d": [98,156], "a": 1 },
						{ "px": [160,256], "src": [64,288], "f": 0, "t": 173, "d": [98,165], "a": 1 },
						{ "px": [256,256], "src": [64,288], "f": 0, "t": 173, "d": [98,168], "a": 1 },
						{ "px": [288,256], "src": [64,288], "f": 0, "t": 173, "d": [98,169], "a": 1 },
						{ "px": [320,256], "src": [64,288], "f": 0, "t": 173, "d": [98,170], "a": 1 },
						{ "px": [384,288], "src": [64,288], "f": 0, "t": 173, "d": [98,192], "a": 1 },
						{ "px": [416,288], "src": [64,288], "f": 0, "t": 173, "d": [98,193], "a": 1 },
						{ "px": [576,64], "src": [96,256], "f": 0, "t": 155, "d": [97,58], "a": 1 },
						{ "px": [576,128], "src": [96,256], "f": 0, "t": 155, "d": [97,98], "a": 1 },
						{ "px": [576,160], "src": [96,256], "f": 0, "t": 155, "d": [97,118], "a": 1 },
						{ "px": [576,192], "src": [96,256], "f": 0, "t": 155, "d": [97,138], "a": 1 },
						{ "px": [576,224], "src": [96,256], "f": 0, "t": 155, "d": [97,158], "a": 1 },
						{ "px": [64,32], "src": [64,224], "f": 0, "t": 135, "d": [96,22], "a": 1 },
						{ "px": [96,32], "src": [64,224], "f": 0, "t": 135, "d": [96,23], "a": 1 },
						{ "px": [128,32], "src": [64,224], "f": 0, "t": 135, "d": [96,24], "a": 1 },
						{ "px": [160,32], "src": [64,224], "f": 0, "t": 135, "d": [96,25], "a": 1 },
						{ "px": [192,32], "src": [64,224], "f": 0, "t": 135, "d": [96,26], "a": 1 },
						{ "px": [224,32], "src": [64,224], "f": 0, "t": 135, "d": [96,27], "a": 1 },
						{ "px": [256,32], "src": [64,224], "f": 0, "t": 135, "d": [96,28], "a": 1 },
						{ "px": [288,32], "src": [64,224], "f": 0, "t": 135, "d": [96,29], "a": 1 },
						{ "px": [320,32], "src": [64,224], "f": 0, "t": 135, "d": [96,30], "a": 1 },
						{ "px": [352,32], "src": [64,224], "f": 0, "t": 135, "d": [96,31], "a": 1 },
						{ "px": [384,32], "src": [64,224], "f": 0, "t": 135, "d": [96,32], "a": 1 },
						{ "px": [416,32], "src": [64,224], "f": 0, "t": 135, "d": [96,33], "a": 1 },
						{ "px": [448,32], "src": [64,224], "f": 0, "t": 135, "d": [96,34], "a": 1 },
						{ "px": [480,32], "src": [64,224], "f": 0, "t": 135, "d": [96,35], "a": 1 },
						{ "px": [512,32], "src": [64,224], "f": 0, "t": 135, "d": [96,36], "a": 1 },
						{ "px": [544,32], "src": [64,224], "f": 0, "t": 135, "d": [96,37], "a": 1 },
						{ "px": [32,192], "src": [32,288], "f": 0, "t": 172, "d": [95,121], "a": 1 },
						{ "px": [64,224], "src": [32,288], "f": 0, "t": 172, "d": [95,142], "a": 1 },
						{ "px": [128,256], "src": [32,288], "f": 0, "t": 172, "d": [95,164], "a": 1 },
						{ "px": [544,256], "src": [32,288], "f": 0, "t": 172, "d": [95,177], "a": 1 },
						{ "px": [192,288], "src": [32,288], "f": 0, "t": 172, "d": [95,186], "a": 1 },
						{ "px": [352,288], "src": [32,288], "f": 0, "t": 172, "d": [95,191], "a": 1 },
						{ "px": [480,256], "src": [96,288], "f": 0, "t": 174, "d": [94,175], "a": 1 },
						{ "px": [576,256], "src": [96,288], "f": 0, "t": 174, "d": [94,178], "a": 1 },
						{ "px": [224,288], "src": [96,288], "f": 0, "t": 174, "d": [94,187], "a": 1 },
						{ "px": [448,288], "src": [96,288], "f": 0, "t": 174, "d": [94,194], "a": 1 },
						{ "px": [576,32], "src": [96,224], "f": 0, "t": 136, "d": [93,38], "a": 1 },
						{ "px": [32,32], "src": [32,224], "f": 0, "t": 134, "d": [92,21], "a": 1 },
						{ "px": [0,96], "src": [64,352], "f": 0, "t": 211, "d": [88,60], "a": 1 },
						{ "px": [608,96], "src": [64,352], "f": 0, "t": 211, "d": [88,79], "a": 1 },
						{ "px": [576,96], "src": [352,256], "f": 0, "t": 163, "d": [83,78], "a": 1 },
						{ "px": [32,96], "src": [320,224], "f": 0, "t": 143, "d": [82,61], "a": 1 }
					],
					"seed": 289370,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				}
			],
			"__neighbours": []
		}
	],
	"worlds": [],
	"dummyWorldIid": "3e1d7f30-6280-11ee-862e-3378b3d72182"
}